"use client";

import { useEffect, useRef } from "react";
import { usePostHog } from "posthog-js/react";

/**
 * Fires a single `seo_page_view` PostHog event on mount, tagged with the
 * surface/slug/locale so SEO entry points can be segmented in funnels
 * (Proposal 10, analytics). PostHog's autocapture handles generic pageviews;
 * this adds the structured SEO dimensions on top.
 */
export function SeoAnalytics({
  surface,
  slug,
  locale,
}: {
  surface: string;
  slug?: string;
  locale: string;
}) {
  const posthog = usePostHog();
  const fired = useRef(false);

  useEffect(() => {
    if (fired.current) return;
    fired.current = true;
    posthog?.capture("seo_page_view", {
      seo_surface: surface,
      seo_slug: slug,
      seo_locale: locale,
    });
  }, [posthog, surface, slug, locale]);

  return null;
}
